import { useState } from 'react';
import { post } from '../Auths/AuthToken';

function ProblemReasonBox({
  reasonNote,
  // soapId = 0,
  patientId,
  visitId,
  onReasonUpdate = () => {},
  editSave = false,
  onCancelReason,
}) {
  const [reasonTxt, setReasonTxt] = useState(
    reasonNote[1] ? reasonNote[1] : ''
  );
  const onSavePblmReason = async () => {
    const response = await post(
      'api/patient/ProgressNote/saveCustomCounselingPblmReason',
      {
        dxId: reasonNote[2],
        provId: reasonNote[3],
        reasonNote: reasonTxt,
        // reasonTxtId: reasonNote[4],
        // soapId: soapId,
        patientId: patientId,
        visitId: visitId,
      }
    );
    if (response.status === 200) {
      onReasonUpdate(response.data.probArr);
      onCancelReason();
    }
  };
  return (
    <div className="modalBackground" style={{ zIndex: '40' }}>
      <div className="mentalValuesMainbox">
        <div className="mentalheader-row identity-header">
          <span className="hdngTxt">Current problem reason:</span>
          <span className="close" onClick={onCancelReason}>
            X
          </span>
        </div>
        <div className="mentalvaluemainBody">
          <span className="mental-note">
            <b>Dx:</b> {reasonNote[0]}
          </span>
          <span className="mental-text">
            <textarea
              id="reasonNote"
              name="reasonNote"
              className="cur-pblm-reason-text-area"
              value={reasonTxt}
              onChange={(e) => setReasonTxt(e.target.value)}
              disabled={!editSave}
            />
          </span>
        </div>
        <div className="">
          {editSave && (
            <span
              className="button-submit right clear-right"
              onClick={onSavePblmReason}
            >
              save
            </span>
          )}
          <span
            className="button-cancel2 right clear-right"
            onClick={onCancelReason}
          >
            Cancel
          </span>
        </div>
      </div>
    </div>
  );
}

export default ProblemReasonBox;
